import { Injectable } from "@angular/core";
import { LABELS_LANGUAGES } from "../../share/labels.model";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { Solicitud } from "src/entity/solicitud";
import { environment } from "src/environments/environment";
import { CustomizationStoreService } from "src/services/customization.store.service";
import { PAGES } from "./status-map.model";
import { WebhooksService } from "src/services/webhooks.service";

@Injectable({
    providedIn: 'root'
})

export class PinUtilsService {

    labels = LABELS_LANGUAGES.es;
    socket = null;
    private readonly _request = new BehaviorSubject<Solicitud>({
        ...new Solicitud(),
        status_code: 'created'
    });
    private readonly _lastThreeNumbersPhone = new BehaviorSubject<string>(null);
    private readonly _request_status = new BehaviorSubject<string>(null);

    currentHeight = 0;
    public REQUEST;
    public REQUEST_STATUS;
  
    private autoAcceptSource = new ReplaySubject<void>();
    public autoAccept$ = this.autoAcceptSource.asObservable();
  
   constructor(private customizationStoreService: CustomizationStoreService) {}

   parseErrorResponse(message) {
    if (Array.isArray(message)) {
      let r = "";
      message.forEach((element) => {
        r += element + " ";
      });
      return {
        title: this.labels.warnings.errorSomeData,
        description: r,
      };
    } else if (message.toLowerCase() == "does not have pin service" || message.toLowerCase() == "does not have clave pin service") {
      return {
        title: 'no-service',
        code: 'no-service',
        description: this.labels.warnings.noPinService
      };
    } else if (message.toLowerCase() == "document number invalid.") {
      return {
        title: this.labels.warnings.wrongDni,
        code: 'dni',
        description: this.labels.warnings.wrongDniDesc
      };
    } else if (message.toLowerCase() == "incorrect support number") {
      return {
        title: this.labels.warnings.error,
        code: 'sop',
        description: this.labels.warnings.wrongSupport,
      };
    } else if (message.toLowerCase() == "incorrect date") {
        return {
          title: this.labels.warnings.wrongDate,
          code: 'nac',
          description: this.labels.warnings.wrongDateDesc
        };
    } else {
      return {
        title: "Error!",
        code: 'unknown',
        description: message,
      };
    }
   }

   readonly request$ = this._request.asObservable();
   readonly request_status$ = this._request_status.asObservable();
   readonly lastThreeNumbersPhone$ = this._lastThreeNumbersPhone.asObservable();

   setGlobalVariables() {
    this.REQUEST = this._request.value;
    this.REQUEST_STATUS = this.REQUEST.status_code;
    this._request_status.next(this.REQUEST_STATUS)
   }

   setRequest(next: Solicitud) {
    this._request.next({ ...next });
    this.setGlobalVariables();
   }

   patch(partial: Partial<Solicitud>) {
    const current = this._request.value;
    this._request.next({ ...current, ...partial });
    this.setGlobalVariables();
   }

   setParameter(parameterKey: string, value: any) {
    const current = this._request.value;
    this._request.next({ ...current, [parameterKey]: value });
    this.setGlobalVariables();
   }

   setRequestStatus(status_code: string) {
    const current = this._request.value;
    this._request.next({ ...current, status_code: status_code });
    this.setGlobalVariables();
   }

   setRequestID(request_id: string) {
    const current = this._request.value;
    this._request.next({ ...current, request_id: request_id });
    this.setGlobalVariables();
   }

    subscribeWS() {
        if (this.socket) {
            return;
        }

        let url = "wss://notifications.dev.belender.net";
        if (environment.env == "qa") {
            url = "wss://notifications.qa.belender.net";
        }
        if (environment.env == "pro") {
            url = "wss://notifications.belender.net";
        }
        if (environment.notificationsBaseUrl) {
            url = environment.notificationsBaseUrl;
        }
        this.socket = new WebSocket(
            `${url}?requests_id=${this._request.value.request_id}&user_id=${this.customizationStoreService.USER_ID}`,
        );
        var self = this;

        // Abre la conexión
        this.socket.onopen = function (event) {
            console.log("Conexión establecida");
        };

        // Maneja los mensajes entrantes
        this.socket.onmessage = function (event) {
            var mensaje = event.data;
            let objMessage = JSON.parse(mensaje);
            self.handlePusherNotification(objMessage);
        };

        // Maneja los errores de la conexión
        this.socket.onerror = function (error) {
            console.log("WebSocket Error: " + error);
            console.error(error);
            //self.setSubscriptionOfRequestOld();
        };

        // Cierra la conexión
        this.socket.onclose = function (event) {
            console.log("Conexión cerrada");
            //self.setSubscriptionOfRequestOld();
        };
    }

    handlePusherNotification(d) {
        if (!d) {
            return;
        }
        if (WebhooksService.shouldIgnoreWebhookStatus(d.status_code)) {
            return;
        }
        this.sendMessageToParent({ type: "websocket", data: d });
        console.warn("message from ws: ", d);

        if (d.person_last_three_phone_number) {
            this._lastThreeNumbersPhone.next(d.person_last_three_phone_number);
        }

        const status = d.status_code;
        if (!status) {
            return;
        }

        if (status.startsWith("failed")) {
            this.disconnectWebsocket();
            this.setRequestStatus(status);
            return;
        }

        if (status.startsWith("abandoned")) {
            this.disconnectWebsocket();
            this.setRequestStatus(status);
            return;
        }

        if (status === "consent_process_completed") {
            this.disconnectWebsocket();
            this.patch({ status_code: status });
            return;
        }

        this.patch({ status_code: status });
    }

    sendMessageToParent(obj) {

      if(obj && obj.type && obj.type === 'widgetHeight') {
        if(obj.data === this.currentHeight) {
            return;
        } else {

            this.currentHeight = obj.data;
        }
      }
      console.log('Message to parent:', obj);
      window.top.postMessage(obj, "*");
    }

    disconnectWebsocket() {
        this.socket && this.socket.close();
        this.socket = null;
  }
  
  public triggerAutoAccept() {
    this.autoAcceptSource.next();
  }

  public clearAutoAccept() {
    this.autoAcceptSource = new ReplaySubject<void>(1);
    this.autoAccept$ = this.autoAcceptSource.asObservable();
  }
}





